import jiantou from "@/assets/lottie/jiantou.json";
import jiantou1 from "@/assets/lottie/jiantou.json";
import p2Img from "./imgs/p2_img.png";
import p5Icon from "./imgs/p5_icon.png";
import p3Icon1 from "./imgs/p3_icon1.png";
import p3Icon2 from "./imgs/p3_icon2.png";
import p3Icon3 from "./imgs/p3_icon3.png";
import p4Img1 from "./imgs/p4_img1.png";
import p4Img2 from "./imgs/p4_img2.png";
import p4Img3 from "./imgs/p4_img3.png";
import p4Img4 from "./imgs/p4_img4.png";
import p6Icon1 from "./imgs/p6_icon1.png";
import p6Icon2 from "./imgs/p6_icon2.png";
import p6Icon3 from "./imgs/p6_icon3.png";

export const p3List = [
	{
		title: "极速定制",
		list: [
			"录制秒级音视频极速复刻",
			"支持 1080P 高质量形象",
			"支持多语种超拟人声音",
		],
		icon: p3Icon1,
		link: "",
	},
	{
		title: "高级定制",
		list: [
			"录制 3～6 分钟音视频高级定制",
			"生成 4K 超清专属数字人形象",
			"支持多语种超拟人声音",
		],
		icon: p3Icon2,
		link: "",
	},
	{
		title: "精品定制",
		list: [
			"高精度精品定制2D、3D模型",
			"专业的妆造、拍摄、精修方案",
			"AI生成技术对面容重塑",
		],
		icon: p3Icon3,
	},
];

export const p4List = [
	{
		title: "合成音频",
		desc: "提供TTS语音生成服务，支持丰富的官方音色和定制的专属音色",
		tags: ["同步合成短音频", "异步合成长音频"],
		img: p4Img1,
	},
	{
		title: "合成视频",
		desc: "提供强大的数字人视频合成技术，只需一段文本或音频即可驱动数字人口型",
		tags: ["合成纯数字人视频", "剪辑器视频", "PPT讲解视频"],
		img: p4Img2,
	},
	{
		title: "实时交互",
		desc: "提供数字人实时音视频流，支持web、APP、一体机多端集成",
		tags: ["文本驱动", "大模型驱动", "音频流驱动"],
		img: p4Img3,
	},
	{
		title: "大模型对话",
		desc: "提供大模型智能对话能力，一键集成DeepSeek、Doubao、GPT等主流大模型",
		tags: ["流式对话", "非流式对话"],
		img: p4Img4,
	},
];

export const p5List = [
	{
		title: "API",
		list: [
			"提供数字人定制、音视频合成、大模型对话等标准接口，方便与现有系统无缝对接",
			"灵活跨平台调用，支持多样业务深度集成",
		],
		link: "https://aibeings-vip.xiaoice.com/developer-doc/show/101",
	},
	{
		title: "SDK",
		list: [
			"内置实时交互能力，简化推流流程，快速构建沉浸式智能体应用",
			"支持Web、Android、iOS三端接入",
		],
		link: "https://aibeings-vip.xiaoice.com/developer-doc/show/64",
	},
];

export const p6Steps = [
	{
		title: "注册账号",
		desc: "打开数字员工平台，注册账号",
		icon: p6Icon1,
	},
	{
		title: "获取SubKey",
		desc: "管理中心>>账号设置>>API密钥",
		icon: p6Icon2,
	},
	{
		title: "接入使用",
		desc: "调用开放能力，驱动数字员工",
		icon: p6Icon3,
	},
];

export const data = {
	p1: {
		title: "全场景数字员工能力中心",
		subtitle: "从这里开始，让数字员工服务触达每个业务场景",
		btn1: {
			text: "立即体验",
			link: "https://aibeings-vip.xiaoice.com",
		},
		btn2: {
			text: "查看文档",
			link: "https://aibeings-vip.xiaoice.com/developer-doc/show",
		},
	},
	p2: {
		title: "面向各类开发者及生态伙伴",
		subtitle: "开放全栈式数字员工核心能力",
		desc: "支持调用方实现高度定制化与深度集成的数字人应用开发，满足多样化业务需求与广泛应用场景",
	},
    p3: {
        title: "已开放的数字人模型",
    },
    p4: {
        title: "可调用的数字人能力",
    },
    p5: {
        title: "灵活的接入方式",
    },
    p6: {
        title: "便捷的对接流程",
        btnText: "注册开发者",
    },
};